import { Image } from '@cowbell/ui';
import { imageMappings } from './imageMappings';

interface ConnectorLogoProps {
  readonly connectorType: string;
  /** A vendor-supplied logo wins over the bundled one. */
  readonly logoUrl?: string;
  readonly className?: string;
}

/**
 * The connector's logo. It always sits on a white well, whatever the theme, so
 * it always uses the light-ground artwork; the dark variants have white ink.
 */
export default function ConnectorLogo({
  connectorType,
  logoUrl,
  className,
}: ConnectorLogoProps) {
  const iconSet = imageMappings[connectorType] ?? imageMappings.default;

  return (
    <Image
      src={logoUrl || iconSet.light}
      alt=""
      fit="contain"
      w="100%"
      h="100%"
      className={className}
    />
  );
}
